/** @jsx jsx */

import { clients } from "utils/clients";
import { jsx, Variable, render, Mutation, SelectionSet, Field, IdScalar, IntScalar } from "graphql-jsx";

type Option = Readonly<{
  id: string;
  weight: number;
}>;

export const UpdateArtistWeight = async (option: Option) => {
  const $id = <Variable name="id" scalar={<IdScalar />} value={option.id} />;
  const $weight = <Variable name="weight" scalar={<IntScalar />} value={option.weight} />;
  const { query, variables } = render(
    <Mutation operationName="UPDATE_ARTIST">
      <SelectionSet
        name="updateArtist"
        argument={{
          where: {
            artist_id: $id
          },
          data: {
            weight: $weight
          }
        }}
      >
        <Field name="artist_id" />
      </SelectionSet>
    </Mutation>
  );

  type Data = Readonly<{
    updateArtist: {
      id: string;
    };
  }>;

  return await clients.artist.request<Data>(query, variables);
};
